import organizerBg from './organizerBg.jpg';

export { organizerBg };
